<ng-container *ngIf="orgTypeId === 1; else eventTemplate">
    <div class="list-group-item">
        <div class="d-flex w-100 justify-content-between">
            <ng-container [ngSwitch]="choosenLanguage">
                <h5 *ngSwitchCase="'de'" class="mb-1">{{course.name_de}}</h5>
                <h5 *ngSwitchCase="'en'" class="mb-1">{{course.name_en}}</h5>
                <h5 *ngSwitchDefault class="mb-1">{{course.name_it}}</h5>
            </ng-container>
            <small>
                <select class="form-select form-select-sm" [(ngModel)]="choosenLanguage">
                    <option value="it" *ngIf="course.name_it && course.description_it">IT</option>
                    <option value="de" *ngIf="course.name_de && course.description_de">DE</option>
                    <option value="en" *ngIf="course.name_en && course.description_en">EN</option>
                </select>
            </small>
        </div>
        <div [ngSwitch]="choosenLanguage">
            <p *ngSwitchCase="'de'" class="mb-1" [innerHTML]="course.description_de"></p>
            <small *ngSwitchCase="'de'"><strong>{{course.courseType.name}}</strong></small>

            <p *ngSwitchCase="'en'" class="mb-1" [innerHTML]="course.description_en"></p>
            <small *ngSwitchCase="'en'"><strong>{{course.courseType.name}}</strong></small>

            <p *ngSwitchDefault class="mb-1" [innerHTML]="course.description_it"></p>
            <small *ngSwitchDefault><strong>{{course.courseType.name}}</strong></small>
        </div>
        <hr />
        <div class="text-end">
            <button type="button" class="btn btn-sm btn-link" (click)="deleteCourseButtonClick()">
                <fa-icon [icon]="icons['faTrashAlt']"></fa-icon>
            </button>
            <button type="button" class="btn btn-sm btn-link" (click)="updateCourseButtonClick()">
                <fa-icon [icon]="icons['faEdit']"></fa-icon>
            </button>
        </div>
    </div>
</ng-container>
<ng-template #eventTemplate>
    <div class="list-group-item">
        <div class="d-flex w-100 justify-content-between">
            <ng-container [ngSwitch]="choosenLanguage">
                <h5 *ngSwitchCase="'de'" class="mb-1">{{course.name_de}}</h5>
                <h5 *ngSwitchCase="'en'" class="mb-1">{{course.name_en}}</h5>
                <h5 *ngSwitchDefault class="mb-1">{{course.name_it}}</h5>
            </ng-container>
            <small>
                <select class="form-select form-select-sm" [(ngModel)]="choosenLanguage">
                    <option value="it" *ngIf="course.description_it">IT</option>
                    <option value="de" *ngIf="course.description_de">DE</option>
                    <option value="en" *ngIf="course.description_en">EN</option>
                </select>
            </small>
        </div>
        <div [ngSwitch]="choosenLanguage">
            <p *ngSwitchCase="'de'" class="mb-1" [innerHTML]="course.description_de"></p>
            <p *ngSwitchCase="'en'" class="mb-1" [innerHTML]="course.description_en"></p>
            <p *ngSwitchDefault class="mb-1" [innerHTML]="course.description_it"></p>
        </div>
        <hr />
        <div class="text-end">
            <button type="button" class="btn btn-sm btn-link" (click)="deleteCourseButtonClick()">
                <fa-icon [icon]="icons['faTrashAlt']"></fa-icon>
            </button>
            <button type="button" class="btn btn-sm btn-link" (click)="updateCourseButtonClick()">
                <fa-icon [icon]="icons['faEdit']"></fa-icon>
            </button>
        </div>
    </div>
</ng-template>
